/* src/app/modules/taxes/quarterly-tax-receipt/quarterly-tax-receipt.component.css */
.my-fixed-item {
  position: fixed;
  word-wrap: break-word;
}
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
ul {
  list-style-type: none;
}
li {
  list-style-type: none;
  margin: auto 10px;
}
.searchTextBox {
  font-size: 14px;
  width: 100%;
}
.mat-mdc-table {
  overflow: auto;
  max-height: 300px;
}
.pdf-container {
  height: 80vh;
}
.flex-container.expense-form-container .second-column {
  width: 5%;
}
.flex-container.expense-form-container .first-column .imageFile {
  max-width: 60%;
  max-height: none;
  margin: 0 auto;
}
.pdf-image-file {
  max-width: 80% !important;
}
.invoice-number-mat-hint {
  display: inline;
  color: red;
  font-weight: 700;
  font-size: 14px;
}
@media (min-width: 992px) {
  .hr-divider {
    width: 85%;
  }
}
@media (min-width: 1023px) {
  .hr-divider {
    width: 100%;
  }
}
@media (min-width: 1200px) {
  .hr-divider {
    width: 85%;
  }
}
@media (min-width: 1400px) {
  .hr-divider {
    width: 100%;
  }
}
@media (min-width: 1400px) {
  .hr-divider {
    width: 90%;
  }
}
@media (min-width: 1900px) {
  .hr-divider {
    width: 85%;
  }
}
@media (max-width: 991px) {
  .flex-container.expense-form-container .first-column .imageFile {
    max-width: 90%;
  }
  .pdf-image-file {
    max-width: 90% !important;
  }
  .width80 {
    width: 100% !important;
  }
}
@media (max-width: 767px) {
  .butonera {
    display: grid;
    justify-content: start;
    grid-gap: 10px;
  }
  .butonera button {
    margin-left: 0 !important;
  }
  .flex-container.expense-form-container {
    flex-direction: column;
  }
  .flex-container.expense-form-container .second-column {
    width: 100%;
  }
  .flex-container.expense-form-container .first-column {
    width: 100%;
  }
}
/*# sourceMappingURL=quarterly-tax-receipt.component.css.map */
